import React, { Component } from 'react';
import Card from '../../../CardNew';
import { PREMIUM } from '../../constants';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import './styles.css';
class RibbonPremium extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.index;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.device = props.device;
    }

    clickHandler(data) {
        this.onClickHandler && this.onClickHandler(data);
    }

    resolveCardType(item) {
        let isLiveTV = false;
        if (item.type && item.type == 'live') {
            if (item.live_enabled && item.live_enabled == 1) {
                isLiveTV = true;
            }
        }

        return isLiveTV ? 'a' : '';
    }

    render() {
        return (
            <div className="ribbon-items ribbon-premium">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    const uri = node_item.src;
                    const cardType = this.resolveCardType(node_item);
                    const dataMetricsRibbon = {
                        node_item: { title: node_item.href.split('/').pop() },
                        node_location: location.pathname,
                        ribbon_title: this.carruselTitle || this.ribbonId,
                    };
                    const coverResize = this.device === 'ps4' && node_item && node_item.image_highlight ? `${node_item.image_highlight}?impolicy=resize&vwidth=400` : node_item && node_item.image_highlight ? node_item.image_highlight : '';
                    let cardProps = {
                        unFocusHandler: this.unFocusHandler,
                        id: key,
                        key: key,
                        ribbonIndex: this.ribbonIndex,
                        ignoreSeenLast: this.ignoreSeenLast,
                        data: node_item,
                        group_id: node_item.group_id || node_item.id,
                        cover: coverResize,
                        hideTitles: this.props.hideTitles,
                        label: node_item.label,
                        type: PREMIUM,
                        title: node_item.title,
                        badgesHtml: badges,
                        typeRender: this.resolveCardType(node_item),
                        dataMetric: {
                            carruselTitle: this.carruselTitle,
                            cardPosition: GeneralRibbonUtils.getPosition(
                                this.items,
                                node_item.title
                            ),
                        },
                        focusable: index === 0,
                        focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusHandler: this.focusHandler,
                        setMetricsEvent: this.setMetricsEvent,
                        href: uri,
                        hideInnerTitle: this.hideInnerTitle,
                        bookmark: node_item.bookmark ? String(node_item.bookmark) : '0',
                        filterTV: node_item.filterTV ? node_item.filterTV : null,
                        ribbonName : this.ribbonName,
                        onClick:
                            cardType === 'a'
                                ? (e) => {
                                      this.dataUpdateMetrics(dataMetricsRibbon);
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.clickHandler(node_item);
                                  }
                                : () => {
                                      this.dataUpdateMetrics(dataMetricsRibbon);
                                  },
                    };
                    return <Card {...cardProps} />;
                })}
            </div>
        );
    }
}

export default RibbonPremium;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonPremium/index.jsx